export interface ReaderEnvironmentConfig {
  sdlc: string
  services: Services
  branchkeys: Branchkeys
}

export interface Services {
  PlayerAPI: string
  MHEReaderAPI: string
  MHEDarkReaderAPI: string
  TTSApi: string
  ContentAgnosticTool: string
}
export interface Branchkeys {
  con: string
  atd: string
}

export const defaultReaderEnvironmentConfig: ReaderEnvironmentConfig = {
  sdlc: '',
  services: {
    PlayerAPI: '',
    MHEReaderAPI: '',
    MHEDarkReaderAPI: '',
    TTSApi: '',
    ContentAgnosticTool: '',
  },
  branchkeys: {
    con: '',
    atd: '',
  },
};
